import React from 'react';
import ButtonChoice from '../Fields/ButtonChoice';

const BuildingsAccidentalDamage = React.createClass({
    propTypes: {
        regenerateQuote: React.PropTypes.func,
    },
    
    regenerateQuote : function() {
        this.props.regenerateQuote();
    },

    render() {
        return (
            <div className="container has-border">
                <div className="summary-question">
                    <ButtonChoice
                        question={'Would you like cover for accidental damage for your building cover?'}
                        fieldName={'building_accidental_damage'}
                        loadCachedValue={true}
                        children={[]}
                        questionId={null}
                        supplementaryText={''}
                        supplementaryTextAfterInput={null}
                        alternateBackground={null}
                        noBorder={true}
                        onChangeTertiary={this.regenerateQuote}
                        helpText={null}
                        options={[
                            {
                                option_text: 'Yes',
                                option_value: 'yes'
                            },
                            {
                                option_text: 'No',
                                option_value: 'no'
                            }
                        ]} />
                </div>
            </div>
        );
    }
});

export default BuildingsAccidentalDamage;



/** WEBPACK FOOTER **
 ** ./src/components/QuoteSummaryFields/BuildingsAccidentalDamage.js
 **/